import { render, staticRenderFns } from "./create-template.vue?vue&type=template&id=bfbe0278&scoped=true&"
import script from "./create-template.vue?vue&type=script&lang=ts&"
export * from "./create-template.vue?vue&type=script&lang=ts&"
import style0 from "./create-template.vue?vue&type=style&index=0&id=bfbe0278&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfbe0278",
  null
  
)

export default component.exports